export default {
    parts: ['container', 'tabBar', 'tabList', 'tab', 'content'],
    baseStyle: {
        container: {
            width: '100%'
        },
        tabBar: {
            overflowX: 'auto',
            width: '100%',
            '&::-webkit-scrollbar': {display: 'none'},
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
        },
        tabList: {
            display: 'flex',
            gap: '16px',
            width: 'fit-content',
            minWidth: '100%'
        },
        tab: {
            flexShrink: 0,
            textStyle: 'labelXs',
            textAlign: 'center',
            p: '8px',
            border: 'none',
            backgroundColor: 'transparent',
            cursor: 'pointer',
            transition: 'border-color 200ms ease, color 200ms ease'
        },
        content: {
            minHeight: '1px'
        }
    }
}
